import React, { useCallback } from 'react';
import { Flex, Typography } from 'antd';
import { CustomModalWithoutButton, CustomButton } from '../../components';

const { Text } = Typography;

export interface SpecialtyBookingCompletedModalProps {
  open: boolean;
  onClose: () => void;
  trackingNumber: string | null;
  providerTitle?: string | null;
}

const SpecialtyBookingCompletedModal: React.FC<
  SpecialtyBookingCompletedModalProps
> = ({ open, onClose, trackingNumber, providerTitle }) => {
  const setModalOpenBridge = useCallback((_next: boolean) => {}, []);
  const title = providerTitle?.trim()
    ? `${providerTitle.trim()} booking completed`
    : 'Booking completed';

  return (
    <CustomModalWithoutButton
      modalOpen={open}
      setModalOpen={setModalOpenBridge}
      modalTitle={title}
      lineHeight='28px'
      fontSize='20px'
      modalSize={600}
      zIndex={1200}
      maskClosable={false}
      closable={false}
      keyboard={false}
    >
      <Flex vertical gap={0} style={{ width: '100%' }}>
        <Typography.Paragraph style={{ marginBottom: 12, marginTop: 0 }}>
          Your tracking number is{' '}
          <Text
            strong
            style={{ userSelect: 'text' }}
            copyable={
              trackingNumber?.trim()
                ? {
                    text: trackingNumber.trim(),
                    tooltips: ['Copy tracking number', 'Copied'],
                  }
                : false
            }
          >
            {trackingNumber?.trim() || '—'}
          </Text>
        </Typography.Paragraph>

        <Flex justify='flex-end' style={{ marginTop: 20 }}>
          <CustomButton
            text='Done'
            bgColor='#000'
            color='#fff'
            fontSize='14px'
            fontWeight='600'
            height='36px'
            borderRadius='8px'
            padding='0 32px'
            onClick={onClose}
          />
        </Flex>
      </Flex>
    </CustomModalWithoutButton>
  );
};

export default SpecialtyBookingCompletedModal;
